import { CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';

import BottomSheet from '../BottomSheet';

export const Container = styled('div')({
  height: '100%',

  padding: '4rem 4rem 0',
  overflow: 'hidden',

  display: 'flex',
  flexDirection: 'column',
});

export const Header = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',

  flexShrink: 0,
});

export const StepContainer = styled('div')({
  width: '100%',

  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',

  marginTop: '2.7rem',
  paddingRight: '1.5rem',

  whiteSpace: 'pre-wrap',
});

export const BodyContainer = styled('div')(({ theme }) => ({
  height: '100%',

  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',

  rowGap: '2rem',

  color: theme.colors.base01,
}));

export const HeaderTitle = styled('div')(({ theme }) => ({
  color: theme.colors.base01,
}));

export const BodyTextContainer = styled('div')({
  whiteSpace: 'pre-wrap',

  textAlign: 'center',
});

type StyledBottomSheetProps = {
  'data-is-staking'?: boolean;
};

export const StyledBottomSheet = styled(BottomSheet)<StyledBottomSheetProps>(({ ...props }) => ({
  '& .MuiPaper-root': {
    height: props['data-is-staking'] ? '71rem' : '54rem',
    position: 'absolute',
    bottom: '0',
  },
}));

export const StyledCircularProgress = styled(CircularProgress)({
  '&.MuiCircularProgress-root': {
    color: '#497EE4',
  },
});

export const IconContainer = styled('div')({
  width: '6.8rem',
  height: '6.8rem',
  '& > svg': {
    width: '6.8rem',
    height: '6.8rem',
  },
});

export const SubTitleContainer = styled('div')(({ theme }) => ({
  marginTop: '-1rem',

  color: theme.colors.base02,

  whiteSpace: 'pre-wrap',

  textAlign: 'center',

  width: '42rem',
}));

export const RedirectButton = styled('button')({
  display: 'flex',
  alignItems: 'center',

  marginTop: '0.6rem',

  padding: '0',

  backgroundColor: 'transparent',

  border: 'none',

  cursor: 'pointer',
});

export const GradientText = styled('div')(({ theme }) => ({
  backgroundImage: theme.colors.gradient01,
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
}));

export const RightChevronIconContainer = styled('div')(({ theme }) => ({
  width: '2.8rem',
  height: '2.8rem',

  marginLeft: '0.4rem',

  '& > svg': {
    width: '2.8rem',
    height: '2.8rem',

    '& > path': {
      fill: theme.colors.base01,
    },
  },
}));

export const URLButton = styled('button')({
  padding: 0,

  margin: '1.2rem 0',

  border: 0,

  color: '#69A5FF',

  backgroundColor: 'transparent',

  cursor: 'pointer',

  '&:hover': {
    opacity: 0.8,
  },
});

export const TxButton = styled('button')({
  marginTop: '-1rem',

  padding: 0,

  border: 0,

  color: '#69A5FF',

  width: '42rem',

  backgroundColor: 'transparent',

  cursor: 'pointer',

  whiteSpace: 'pre-wrap',

  textAlign: 'center',

  wordWrap: 'break-word',

  '&:hover': {
    opacity: 0.8,
  },
});
